import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="bg-white pt-32 pb-20" data-testid="page-404">
      <div className="mx-auto max-w-xl px-4 text-center">
        <p className="font-display text-7xl font-semibold text-blue-900">404</p>
        <h1 className="font-display mt-4 text-2xl sm:text-3xl font-semibold text-slate-900">Page not found</h1>
        <p className="mt-3 text-slate-600">The page you're looking for has moved or doesn't exist.</p>
        <Link to="/" className="inline-block mt-8">
          <Button className="bg-blue-900 hover:bg-blue-950 text-white">Back to home</Button>
        </Link>
      </div>
    </div>
  );
}
